var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFooterMail = function SvgFooterMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 17.171 13.59"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18718",
    d: "M2.386.6h12.4a1.554 1.554 0 0 1 1.55 1.549v9.292a1.554 1.554 0 0 1-1.55 1.549h-12.4a1.554 1.554 0 0 1-1.55-1.549V2.149A1.554 1.554 0 0 1 2.386.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 18719",
    d: "m16.336 2.149-7.75 5.42-7.75-5.42"
  }))));
};
export default SvgFooterMail;